import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetListsComponent } from "../Components/WidgetListsComponent";
import { PopupListsComponent } from "../Popups/PopupListsComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { data } from "jquery";

export enum AnsichtVisibilityEnum {
    Public, Private, All
}
export class WidgetListsProps {
    public title: LanguageString;
    public art: AnsichtVisibilityEnum;
    public excludeAdministrative: boolean;

    constructor() {
        this.title = new LanguageString();
        this.art = AnsichtVisibilityEnum.All;
        this.excludeAdministrative = true;
    }
}

export class WidgetLists extends WidgetBase {
    props: WidgetListsProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetListsProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.Lists;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (this.props.title == null)
                this.props.title = new LanguageString();

            if (this.props.art == null)
                this.props.art = AnsichtVisibilityEnum.All;

            if (this.props.excludeAdministrative === undefined || this.props.excludeAdministrative === null)
                this.props.excludeAdministrative = true;
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetListsComponent({
            widget: this,
            title: this.props.title
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupListsComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}